import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map } from 'immutable';
import classNames from 'classnames';

import config from '../../../config';

/**
 * Project text area component.
 *
 * @param props {Object}.
 * @param props.id {String} Id of control.
 * @param props.name {String} Name of control.
 * @param props.label {String} Label of control.
 * @param props.hideLabel {Boolean} Keeps the label for screen readers only, e.g. When a card title already names the field.
 */
const ProjectTextAreaComponent = ({ id, name, field, label, hideLabel = false, onTextChange }) => {
  const className = classNames({ 'dirty-field': field.get('dirty') }, 'form-control');
  const type = config.values.getIn(['project', 'types', 'PROJECT']);

  return (
    <div className="form-group">
      <label className={hideLabel ? 'sr-only' : 'field-label'} htmlFor={id}>
        {label}
      </label>
      <textarea
        className={className}
        id={id}
        name={name}
        onChange={event => onTextChange({ event, data: { type } })}
        rows="3"
        value={field.get('name')}
      />
    </div>
  );
};

ProjectTextAreaComponent.propTypes = {
  field: PropTypes.instanceOf(Map).isRequired,
  hideLabel: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onTextChange: PropTypes.func.isRequired,
};

export const ProjectTextArea = memo(ProjectTextAreaComponent);
